import { Tooltip, TooltipProps } from "@mantine/core";
import React from "react";

interface Props extends TooltipProps {
  optional?: string;
}

const CustomTooltip = ({ label, children, optional, ...tooltipProps }: Props) => {
  // Ensure children is a valid React element that supports refs
  const childrenWithRef = React.isValidElement(children) ? (
    children
  ) : (
    <span>{children}</span>
  );

  if (!label && !(optional && optional.length > 0)) {
    return <>{childrenWithRef}</>;
  }

  if (optional && optional.length > 0) {
    return (
      <Tooltip
        label={label || ""}
        w={tooltipProps.w ?? 220}
        multiline={tooltipProps.multiline ?? true}
        withArrow={tooltipProps.withArrow ?? true}
        {...tooltipProps}
      >
        {childrenWithRef}
      </Tooltip>
    );
  }

  return (
    <Tooltip
      label={label || ""}
      maw={tooltipProps.maw ?? 350}
      multiline={tooltipProps.multiline ?? true}
      withArrow={tooltipProps.withArrow ?? true}
      {...tooltipProps}
    >
      {childrenWithRef}
    </Tooltip>
  );
};

export default CustomTooltip;